/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./mobile-header.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./mobile-header.component";
var styles_MobileHeaderComponent = [i0.styles];
var RenderType_MobileHeaderComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_MobileHeaderComponent, data: {} });
export { RenderType_MobileHeaderComponent as RenderType_MobileHeaderComponent };
export function View_MobileHeaderComponent_0(_l) { return i1.ɵvid(0, [i1.ɵncd(null, 0)], null, null); }
export function View_MobileHeaderComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "cc-mobile-header", [], null, null, null, View_MobileHeaderComponent_0, RenderType_MobileHeaderComponent)), i1.ɵdid(1, 114688, null, 0, i2.MobileHeaderComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var MobileHeaderComponentNgFactory = i1.ɵccf("cc-mobile-header", i2.MobileHeaderComponent, View_MobileHeaderComponent_Host_0, {}, {}, ["*"]);
export { MobileHeaderComponentNgFactory as MobileHeaderComponentNgFactory };
